import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";
import { insertUserInterruptEntry } from "./utils";
import { clientGeneratableIdSchema } from "../id";

export const interruptPersonalChatSchema = z.object({
  entryId: clientGeneratableIdSchema,
  chatId: z.string(),
});

export const interruptPersonalChat = mutator({
  schema: interruptPersonalChatSchema,
  resolve: {},
  permissions: {
    none: "the chat is resolved through the caller’s own personalChats row; entries are written only into that chat",
  },
  fn: async ({ tx, ctx, args: { entryId, chatId } }) => {
    const { userId } = ctx;
    const [pc] = await tx.run(
      zql.personalChats.where("chatId", chatId).where("userId", userId)
    );
    if (!pc) throw userFacingError("Personal chat not found");

    const createdAt = Date.now();

    const lastEntries = await tx.run(
      zql.chatEntries
        .where("chatId", chatId)
        .orderBy("createdAt", "desc")
        .limit(1)
    );
    const previousEntryId = lastEntries[0]?.id ?? null;

    await insertUserInterruptEntry(tx, {
      id: entryId,
      chatId,
      createdAt,
      previousEntryId,
      tenantId: ctx.tenantId,
    });

    await tx.mutate.chats.update({
      id: chatId,
      lastChatEntryType: "UserInterrupt",
      awaitingAction: false,
      respondingAt: null,
    });

    await tx.mutate.personalChats.update({
      id: pc.id,
      lastActiveAt: createdAt,
    });
  },
});
